import * as propTypes from 'prop-types';
import React from 'react';
import { getRelevanceSorting } from '../../helpers/getSortingBasedOnMarket';
import { post } from '../../helpers/http';
import { __ } from '../../helpers/TranslationService';
import { ICountryCode } from '../../interfaces';

interface IState {
    cruiseNid: string;
}

interface IProps {
    className?: string;
}

export class SearchCruise extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            cruiseNid: '',
        };
    }

    static contextTypes = {
        contentEndpoint: propTypes.string,
        apiHost: propTypes.string,
        brandConfig: propTypes.any,
        countryCode: propTypes.any,
    };

    replaceRelevanceSortString(): string {
        return getRelevanceSorting({ market: this.context.countryCode as ICountryCode });
    }

    handleChange = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ cruiseNid: e.target.value });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const {
            contentEndpoint,
            apiHost,
            brandConfig: { slugs },
        } = this.context;
        const url = `${apiHost}/cruises/search`;
        const searchSlug = slugs.find((item) => item.slugName === 'searchresults').slugValue;
        const urlNotFound = `/${searchSlug}?cruiseNids=${this.state.cruiseNid}`;
        const relevanceSortString: string = this.replaceRelevanceSortString();
        const searchParams = {
            filterParams: {
                cruiseNids: this.state.cruiseNid,
            },
            limit: 1,
            offset: 0,
            sortString: relevanceSortString,
            page: 1,
        };
        if (this.state.cruiseNid.length) {
            post(url, searchParams)
                .then((res) => {
                    const cruises = res.cruises;
                    if (cruises?.length) {
                        window.location.href = `${cruises[0].cruisePageUrl}`;
                    } else {
                        window.location.href = urlNotFound;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    render() {
        return (
            <form
                onSubmit={this.handleSubmit}
                className={`search-cruise${this.props.className ? ' ' + this.props.className : ''}`}
            >
                <input
                    type="text"
                    value={this.state.cruiseNid || ''}
                    onChange={this.handleChange}
                    placeholder={__('insert cruise ID', 'dreamlines')}
                />
                <button className="icon-magnifyingGlass" />
            </form>
        );
    }
}
